import axios from '../utils/axios';
let infoApi={
    // 新增
    addInfo(params, success){
        axios('/info/addinfo', params, success)
    },
    // 获取用户列表
    getInfo(params, success){
        axios('/info/getinfo', params, success)
    },
    // 修改信息状态
    updateInfo(params, success){
        axios('/info/updateinfo', params, success)
    },
    // 删除
    delInfo(params, success){
        axios('/info/deleteinfo', params, success)
    },


}
export default infoApi


// WEBPACK FOOTER //
// ./src/api/info.js